import { Link } from 'react-router-dom';
import { useState } from 'react';
import HeroSection from '../../../components/HeroSection';
import { AccessTime as AccessTimeIcon } from '@mui/icons-material';
import { ArrowBackIos as ArrowBackIosIcon, ArrowForwardIos as ArrowForwardIosIcon } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';

const blogData = [
    {
        id: 1,
        img: "../images/rd-rental-software-blog.jpg",
        category: "Vehicle Rental Software",
        link: "/blog/vehicle-rental-management-software",
        title: "Vehicle Rental Management Software: The Future of Rental Businesses",
        description:
            "Discover how modern vehicle rental management software helps rental businesses automate bookings, manage fleets efficiently, and scale operations with ease.",
        publishDate: "27/11/2024",
    },
    {
        id: 2,
        img: "../images/fleet-management-rd-rental.jpg",
        category: "Fleet Management",
        link: "/blog/fleet-management-rental-software",
        title: "How Rental Software Improves Fleet Management Efficiency",
        description:
            "Learn how advanced rental software simplifies fleet management by tracking vehicle availability, maintenance, and usage in real time for better business control.",
        publishDate: "27/11/2024",
    },
    {
        id: 3,
        img: "../images/rd-rental-business-operations.png",
        category: "Rental Business Operations",
        link: "/blog/rental-business-automation",
        title: "How Rental Management Software Automates Rental Business Operations",
        description:
            "Explore how rental management software streamlines daily operations, reduces manual work, and improves customer experience for vehicle rental businesses.",
        publishDate: "27/11/2024",
    },
];


const Blog = () => {
    const cardsPerPage = 6;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(blogData.length / cardsPerPage);
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentBlogData = blogData.slice(startIndex, endIndex);

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div style={{ backgroundColor: '#f3f4f6', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Helmet>
                <title>Vehicle Rental Management Software Blog | RD Rental</title>
                <meta
                    name="description"
                    content="Insights, guides, and best practices for vehicle rental businesses. Learn about fleet management, rental software, automation, and growth strategies."
                />
                <link rel="canonical" href="https://yourdomain.com/blogs" />
            </Helmet>
            <HeroSection
                mainHeading="Vehicle Rental Management Software Blog"
                backgroundImage="../images/blog-rd-rental.png"
            />

            <section style={{ padding: '2rem 1rem', textAlign: 'center' }}>
                <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                    Insights & Resources for Vehicle Rental Businesses
                </h1>
                <p style={{ maxWidth: '900px', margin: '0 auto', color: '#4B5563' }}>
                    Explore expert insights, product updates, and best practices to help rental companies
                    manage fleets, automate operations, and grow using modern vehicle rental management software.
                </p>
            </section>

            <section style={{ width: '100%', padding: '2rem 1rem', display: 'flex', justifyContent: 'center' }}>
                <div
                    style={{
                        maxWidth: '1280px',
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '2rem',
                    }}
                >
                    {currentBlogData.map((item) => (
                        <div
                            key={item.id}
                            style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '0.5rem',
                                padding: '1rem',
                                position: 'relative',
                                transition: 'box-shadow 0.3s',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <div style={{ position: 'relative', marginBottom: '1rem' }}>
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    style={{
                                        width: '100%',
                                        borderRadius: '0.5rem',
                                        transition: 'transform 0.3s',
                                    }}
                                    className="hover:scale-105"
                                />
                                <p
                                    style={{
                                        position: 'absolute',
                                        bottom: '0',
                                        left: '0',
                                        margin: '1rem',
                                        backgroundColor: '#167AC3',
                                        color: '#ffffff',
                                        padding: '0.75rem',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {item.category}
                                </p>
                            </div>
                            <div style={{ marginTop: '5px', flexGrow: 1 }}>
                                <Link to={`${item.link}`} style={{ textDecoration: 'none' }}>
                                    <h2
                                        style={{
                                            fontSize: '1.25rem',
                                            margin: '1rem 0',
                                            fontWeight: 'bold',
                                            color: '#000000',
                                            cursor: 'pointer',
                                            transition: 'color 0.3s',
                                        }}
                                    >
                                        {item.title}
                                    </h2>
                                </Link>
                                <p style={{ marginBottom: '1rem', color: '#6B7280', fontSize: '0.875rem' }}>
                                    {item.description}
                                </p>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <AccessTimeIcon style={{ width: '1rem', color: '#6B7280' }} />
                                        <p style={{ marginLeft: '0.5rem', fontSize: '0.875rem', color: '#6B7280' }}>
                                            {item.publishDate}
                                        </p>
                                    </div>
                                    <Link
                                        to={item.link}
                                        style={{
                                            width: '3rem',
                                            height: '3rem',
                                            padding: '1rem',
                                            borderRadius: '50%',
                                            backgroundColor: 'transparent',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '2px solid #6B7280',
                                            transition: 'color 0.3s, border-color 0.3s',
                                        }}
                                    >
                                        <ArrowForwardIosIcon />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section style={{ width: '100%', padding: '2rem 1rem', display: 'flex', justifyContent: 'center' }}>
                <div
                    style={{
                        maxWidth: '1280px',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '1rem 2rem',
                    }}
                >
                    <button
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                        style={{
                            fontWeight: '600',
                            color: '#167AC3',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                            opacity: currentPage === 1 ? 0.5 : 1,
                        }}
                    >
                        <ArrowBackIosIcon style={{ marginRight: '0.5rem' }} /> <span>Previous Page</span>
                    </button>
                    <button
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        style={{
                            fontWeight: '600',
                            color: '#167AC3',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                            opacity: currentPage === totalPages ? 0.5 : 1,
                        }}
                    >
                        <span>Next Page</span> <ArrowForwardIosIcon style={{ marginLeft: '0.5rem' }} />
                    </button>
                </div>
            </section>

            <style>{`
                @media (max-width: 768px) {
                    /* Mobile view: 1 column grid layout */
                    div[style*="display: grid"] {
                        grid-template-columns: 1fr !important;  /* Enforce 1 column */
                    }
                }
            `}</style>
        </div>
    );
};

export default Blog;
